import { render, staticRenderFns } from "./SectionRules.vue?vue&type=template&id=52bd75d5&"
import script from "./SectionRules.vue?vue&type=script&lang=js&"
export * from "./SectionRules.vue?vue&type=script&lang=js&"
import style0 from "./SectionRules.vue?vue&type=style&index=0&id=52bd75d5&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports